export function setPagecontactLoading (state, loading = false) {
  state.pagecontactLoading = loading
}
